import {
  FaRegUser,
  FaShoppingBag,
  FaCartPlus,
  FaRegHeart,
} from "react-icons/fa";
import { CiCreditCard1, CiLogout, CiLocationOn } from "react-icons/ci";
import men_1 from "../assets/men-1.png";
import men_2 from "../assets/men-2.png";
import men_3 from "../assets/men-3.png";
import men_4 from "../assets/men-4.png";
import men_5 from "../assets/men-5.png";

export const userProfile = [
  {
    id: 1,
    title: "Profile",
    icon: <FaRegUser />,
    link: "/user/profile",
  },
  {
    id: 2,
    title: "My Wish List",
    icon: <FaRegHeart />,
    link: "/user/favorite",
  },
  {
    id: 3,
    title: "Address Book",
    icon: <CiLocationOn />,
    link: "/user/address",
  },
  {
    id: 4,
    title: "Order History",
    icon: <FaCartPlus />,
    link: "/user/order_history",
  },
  {
    id: 5,
    title: "Card Detail",
    icon: <CiCreditCard1 />,
    link: "/user/card",
  },
];

export const men = [
  {
    id: 1,
    title: "club de nuit milestone",
    perfumeBy: "ARMAF",
    type: ["106ml", "200ml"],
    price: 51.95,
    previous: 120.0,
    image: men_1,
  },
  {
    id: 2,
    title: "club de nuit milestone",
    perfumeBy: "ARMAF",
    type: ["106ml", "200ml"],
    price: 51.95,
    previous: 120.0,
    image: men_2,
  },
  {
    id: 3,
    title: "club de nuit milestone",
    perfumeBy: "ARMAF",
    type: ["106ml", "200ml"],
    price: 51.95,
    previous: 120.0,
    image: men_3,
  },
  {
    id: 4,
    title: "club de nuit milestone",
    perfumeBy: "ARMAF",
    type: ["106ml", "200ml"],
    price: 51.95,
    previous: 120.0,
    image: men_4,
  },
  {
    id: 5,
    title: "club de nuit milestone",
    perfumeBy: "ARMAF",
    type: ["106ml", "200ml"],
    price: 51.95,
    previous: 120.0,
    image: men_5,
  },
];
